import Subsection from "../Subsection";
import styles from "./ThreeStepsSection.module.scss";
import StepCard from "./components/StepCard";
import useTranslationHook from "hooks/useTranslationHook";
import wrapperHOC from "@Utils/wrapperHOC";
import Image from "@Components/Image";
import DottedDownArrow from "@Icons/DottedDownArrow";
import { SCREEN_SIZE, useResponsiveness } from "hooks/useResponsiveness";

const ThreeStepsSection = ({
  isDesktop = false,
  title: customTitle,
  subtitle: customSubtitle,
  card1TitleOverride,
  card1SubTitleOverride,
  card2TitleOverride,
  card2SubTitleOverride,
  card3TitleOverride,
  card3SubTitleOverride,
}: {
  isDesktop?: boolean;
  title?: string;
  subtitle?: string;
  card1TitleOverride?: string;
  card1SubTitleOverride?: string;
  card2TitleOverride?: string;
  card2SubTitleOverride?: string;
  card3TitleOverride?: string;
  card3SubTitleOverride?: string;
}) => {
  const { isAbove } = useResponsiveness();
  const { t } = useTranslationHook();
  const isDesktopBelowMD = isDesktop && isAbove(SCREEN_SIZE.MD, false);
  const subSecTitle = customTitle || t("home.threesteps.bookingsection.subtitle");
  const subSecSubTitle = customSubtitle || t("home.threesteps.bookingsection.subsubtitle");
  const card1Title = card1TitleOverride || t("home.threesteps.bookingsection.card1title");
  const card1SubTitle = card1SubTitleOverride || t("home.threesteps.bookingsection.card1subtitle");
  const card2Title = card2TitleOverride || t("home.threesteps.bookingsection.card2title");
  const card2SubTitle = card2SubTitleOverride || t("home.threesteps.bookingsection.card2subtitle");
  const card3Title = card3TitleOverride || t("home.threesteps.bookingsection.card3title");
  const card3SubTitle = card3SubTitleOverride || t("home.threesteps.bookingsection.card3subtitle");

  return (
    <Subsection
      title={subSecTitle}
      subtitle={subSecSubTitle}
      isDesktop={isDesktopBelowMD}
      // isTablet={isTablet}
      // tabletStyles={styles.tabStyles}
    >
      {isDesktop ? (
        <div className={styles.threeStepsDesktop}>
          <StepCard
            stepNumber={1}
            imgSrc="https://static-assets.amberstudent.com/images/bookings-steps-hd-1.svg"
            title={card1Title}
            subTitle={card1SubTitle}
            showArrow
            isDesktop
          />
          <StepCard
            stepNumber={2}
            imgSrc="https://static-assets.amberstudent.com/images/bookings-steps-hd-2.svg"
            title={card2Title}
            subTitle={card2SubTitle}
            showArrow
            isDesktop
          />
          <StepCard
            stepNumber={3}
            imgSrc="https://static-assets.amberstudent.com/images/bookings-steps-hd-3.svg"
            title={card3Title}
            subTitle={card3SubTitle}
            isDesktop
          />
        </div>
      ) : (
        <div className={styles.contentContainer}>
          <div className={styles.contentInner}>
            <Image
              src="https://static-assets.amberstudent.com/images/bookings-steps-hd-1.svg"
              height={24}
              width={24}
              alt={card1Title}
            />
            <div className={styles.contentTextInner}>
              <div className={styles.cardTitle}>{card1Title}</div>
              <div className={styles.cardSubTitle}>{card1SubTitle}</div>
            </div>
            <div className={styles.dottedDownArrow}>
              <DottedDownArrow />
            </div>
          </div>
          <div className={styles.contentInner}>
            <Image
              src="https://static-assets.amberstudent.com/images/bookings-steps-hd-2.svg"
              height={24}
              width={24}
              alt={card2Title}
            />
            <div className={styles.contentTextInner}>
              <div className={styles.cardTitle}>{card2Title}</div>
              <div className={styles.cardSubTitle}>{card2SubTitle}</div>
            </div>
            <div className={styles.dottedDownArrow}>
              <DottedDownArrow />
            </div>
          </div>
          <div className={styles.contentInner}>
            <Image
              src="https://static-assets.amberstudent.com/images/bookings-steps-hd-3.svg"
              height={24}
              width={24}
              alt={card3Title}
            />
            <div className={styles.contentTextInner}>
              <div className={styles.cardTitle}>{card3Title}</div>
              <div className={styles.cardSubTitle}>{card3SubTitle}</div>
            </div>
          </div>
        </div>
      )}
    </Subsection>
  );
};

export default wrapperHOC(ThreeStepsSection, {
  componentName: "ThreeStepsSection-Home",
  showForChina: true,
  showForMiniProgram: false,
  showForApp: false,
});
